export const categories = [
  { slug: 'romance', name: '浪漫爱情', icon: 'ri-heart-line', count: 1280 },
  { slug: 'action', name: '动作热血', icon: 'ri-fire-line', count: 856 },
  { slug: 'thriller', name: '悬疑惊悚', icon: 'ri-ghost-line', count: 432 },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line', count: 967 },
  { slug: 'comedy', name: '轻松喜剧', icon: 'ri-emotion-happy-line', count: 645 },
  { slug: 'drama', name: '都市剧情', icon: 'ri-building-line', count: 723 },
  { slug: 'bl', name: 'BL向', icon: 'ri-star-line', count: 512 },
  { slug: 'gl', name: 'GL向', icon: 'ri-sun-line', count: 289 },
];

export const comics = [
  {
    id: 'comic-1',
    slug: 'secretarys-secret',
    title: '秘书的秘密',
    author: '金秀贤',
    category: 'romance',
    categoryName: '浪漫爱情',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20style%2C%20elegant%20female%20protagonist%20in%20office%20attire%2C%20soft%20warm%20lighting%2C%20clean%20minimal%20background%2C%20webtoon%20art%20style%2C%20delicate%20linework%2C%20subtle%20color%20palette%20with%20warm%20tones%2C%20professional%20romance%20theme%2C%20gently%20lit%20scene&width=800&height=1100&seq=comic-cover-001&orientation=portrait',
    status: '连载中',
    rating: 4.8,
    views: 2830000,
    chapters: 67,
    latestChapter: '第67话 - 意外的告白',
    updatedAt: '2026-07-02',
    description: '在大企业担任秘书的林恩智，意外发现了社长不可告人的秘密。从此，她与社长之间展开了一场充满危险与诱惑的禁忌之恋。当秘密成为纽带，爱情与背叛只有一线之隔...',
    tags: ['办公室恋情', '禁忌之恋', '年上', '虐心'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-2',
    slug: 'return-of-the-legend',
    title: '传奇归来',
    author: '李正浩',
    category: 'action',
    categoryName: '动作热血',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20illustration%2C%20powerful%20male%20warrior%20with%20dark%20armor%2C%20dramatic%20lighting%20from%20above%2C%20clean%20dark%20background%20with%20subtle%20glow%2C%20webtoon%20action%20style%2C%20dynamic%20pose%2C%20intense%20expression%2C%20fantasy%20warrior%20theme%2C%20sharp%20linework&width=800&height=1100&seq=comic-cover-002&orientation=portrait',
    status: '连载中',
    rating: 4.9,
    views: 5120000,
    chapters: 124,
    latestChapter: '第124话 - 决战前夕',
    updatedAt: '2026-07-02',
    description: '曾经的最强战士被同伴背叛而陨落，百年之后他奇迹般重生归来。面对已经完全陌生的世界，他必须重新踏上强者之路，向那些背叛者复仇。',
    tags: ['重生', '复仇', '战斗', '逆袭'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-3',
    slug: 'shadow-detective',
    title: '暗影侦探',
    author: '朴敏俊',
    category: 'thriller',
    categoryName: '悬疑惊悚',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20noir%20illustration%2C%20detective%20in%20trench%20coat%20under%20streetlight%2C%20dark%20rainy%20alley%20atmosphere%2C%20moody%20cinematic%20lighting%2C%20mystery%20theme%2C%20clean%20webtoon%20art%20style%2C%20deep%20shadows%2C%20suspenseful%20mood%2C%20urban%20night%20scene&width=800&height=1100&seq=comic-cover-003&orientation=portrait',
    status: '连载中',
    rating: 4.7,
    views: 1890000,
    chapters: 42,
    latestChapter: '第42话 - 最后的线索',
    updatedAt: '2026-07-01',
    description: '前刑警姜宇镇因一次意外获得了看穿谎言的能力。他开设私人侦探所，接手各种离奇案件。每一起案件背后都隐藏着惊人的真相，而他自己也被卷入了一场巨大的阴谋之中。',
    tags: ['侦探', '超能力', '悬疑', '都市'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-4',
    slug: 'magic-academy',
    title: '魔法学院',
    author: '崔智恩',
    category: 'fantasy',
    categoryName: '奇幻冒险',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20academy%20illustration%2C%20young%20magic%20student%20holding%20glowing%20book%2C%20magical%20sparkles%20and%20runes%2C%20clean%20bright%20background%2C%20webtoon%20fantasy%20style%2C%20vibrant%20magical%20auras%2C%20school%20uniform%20with%20cape%2C%20whimsical%20atmosphere&width=800&height=1100&seq=comic-cover-004&orientation=portrait',
    status: '连载中',
    rating: 4.6,
    views: 1560000,
    chapters: 89,
    latestChapter: '第89话 - 期末考试',
    updatedAt: '2026-07-01',
    description: '出身平凡的李夏恩被全国最顶尖的魔法学院录取。在这个充满魔法与奇迹的校园里，她发现自己的身世远比想象中更加神秘。友情、冒险与成长，魔法学院的故事就此展开。',
    tags: ['魔法', '校园', '成长', '奇幻'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-5',
    slug: 'coffee-prince',
    title: '咖啡王子',
    author: '韩智慧',
    category: 'comedy',
    categoryName: '轻松喜剧',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romantic%20comedy%20illustration%2C%20handsome%20barista%20making%20coffee%20in%20cozy%20cafe%2C%20warm%20sunlight%20through%20window%2C%20clean%20bright%20interior%2C%20webtoon%20comedy%20style%2C%20lighthearted%20atmosphere%2C%20soft%20colors%2C%20charming%20smile&width=800&height=1100&seq=comic-cover-005&orientation=portrait',
    status: '已完结',
    rating: 4.5,
    views: 3450000,
    chapters: 55,
    latestChapter: '第55话 - 最后的拿铁（完）',
    updatedAt: '2026-06-15',
    description: '为了还债不得不打工的富家千金朴秀雅，在一家精品咖啡店遇到了传说中的"咖啡王子"。两人从互相看不顺眼到渐生情愫，一段甜到爆的浪漫喜剧就此拉开序幕。',
    tags: ['咖啡', '浪漫喜剧', '反差萌', '甜宠'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-6',
    slug: 'city-of-glass',
    title: '玻璃之城',
    author: '金泰妍',
    category: 'drama',
    categoryName: '都市剧情',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20illustration%2C%20elegant%20woman%20looking%20out%20glass%20skyscraper%20window%2C%20cityscape%20background%2C%20melancholic%20mood%2C%20clean%20modern%20style%2C%20webtoon%20drama%20art%2C%20rain%20on%20glass%2C%20reflective%20atmosphere%2C%20sophisticated%20color%20palette&width=800&height=1100&seq=comic-cover-006&orientation=portrait',
    status: '连载中',
    rating: 4.4,
    views: 1230000,
    chapters: 38,
    latestChapter: '第38话 - 破碎的信任',
    updatedAt: '2026-06-30',
    description: '在首尔最繁华的江南区，四位女性的生活因一次意外而交织在一起。她们每个人都有着光鲜亮丽的外表下不为人知的伤痛。在这座玻璃之城中，每个人都在寻找属于自己的出口。',
    tags: ['群像剧', '都市女性', '成长', '情感'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-7',
    slug: 'blooming-season',
    title: '花开时节',
    author: '姜美来',
    category: 'bl',
    categoryName: 'BL向',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20romance%20illustration%2C%20two%20young%20men%20standing%20under%20cherry%20blossom%20tree%2C%20soft%20spring%20lighting%2C%20gentle%20romantic%20atmosphere%2C%20clean%20webtoon%20style%2C%20pastel%20pink%20and%20white%20tones%2C%20delicate%20art%2C%20tender%20moment&width=800&height=1100&seq=comic-cover-007&orientation=portrait',
    status: '连载中',
    rating: 4.7,
    views: 2100000,
    chapters: 72,
    latestChapter: '第72话 - 樱花树下的约定',
    updatedAt: '2026-07-02',
    description: '性格内向的高中生韩宇贤转学到了新的学校，遇到了阳光开朗的学长林泰民。在樱花盛开的春天，两人之间展开了一段青涩而真挚的校园恋情。',
    tags: ['校园', '青春', '纯爱', '成长'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-8',
    slug: 'moonlight-garden',
    title: '月光花园',
    author: '刘美娜',
    category: 'gl',
    categoryName: 'GL向',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20GL%20romance%20illustration%2C%20two%20women%20sitting%20in%20moonlit%20garden%2C%20elegant%20and%20dreamy%20atmosphere%2C%20soft%20moonlight%20through%20flowers%2C%20clean%20webtoon%20style%2C%20gentle%20romance%20theme%2C%20cool%20silver%20and%20purple%20tones%2C%20serene%20mood&width=800&height=1100&seq=comic-cover-008&orientation=portrait',
    status: '连载中',
    rating: 4.6,
    views: 1450000,
    chapters: 48,
    latestChapter: '第48话 - 月光下的低语',
    updatedAt: '2026-06-28',
    description: '园艺师尹瑞安受邀为一栋神秘庄园打造花园，庄园的主人是一位美丽却冷漠的女性。在修剪花草的日子里，两人在月光下的花园中渐渐敞开了心扉。',
    tags: ['园艺', '治愈', '慢热', '温馨'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-9',
    slug: 'blood-rose',
    title: '血色玫瑰',
    author: '安俊宇',
    category: 'romance',
    categoryName: '浪漫爱情',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20romance%20illustration%2C%20woman%20holding%20single%20red%20rose%20against%20dark%20background%2C%20dramatic%20contrast%20lighting%2C%20gothic%20romance%20theme%2C%20clean%20webtoon%20art%20style%2C%20deep%20red%20accents%2C%20mysterious%20mood%2C%20elegant%20dark%20aesthetic&width=800&height=1100&seq=comic-cover-009&orientation=portrait',
    status: '连载中',
    rating: 4.8,
    views: 2670000,
    chapters: 56,
    latestChapter: '第56话 - 荆棘之路',
    updatedAt: '2026-07-02',
    description: '吸血鬼贵族与人类少女之间不被允许的爱情。在血与玫瑰交织的世界里，他们能否突破种族的界限，守护这段禁忌之恋？一场横跨百年的爱恨纠缠就此展开。',
    tags: ['吸血鬼', '禁忌之恋', '虐心', '浪漫'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-10',
    slug: 'iron-chef-korea',
    title: '铁厨韩国',
    author: '李尚宇',
    category: 'action',
    categoryName: '动作热血',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cooking%20competition%20illustration%2C%20intense%20chef%20holding%20flaming%20pan%20in%20professional%20kitchen%2C%20dramatic%20cooking%20action%2C%20clean%20webtoon%20style%2C%20warm%20firelight%2C%20competitive%20energy%2C%20dynamic%20pose%2C%20modern%20kitchen%20background&width=800&height=1100&seq=comic-cover-010&orientation=portrait',
    status: '连载中',
    rating: 4.3,
    views: 980000,
    chapters: 35,
    latestChapter: '第35话 - 终极对决',
    updatedAt: '2026-06-29',
    description: '街头小摊出身的青年厨师金哲秀，凭借过人天赋闯入韩国最顶级的厨艺大赛。在这里他将遇到各种强大的对手，用美食征服所有人的味蕾。',
    tags: ['料理', '竞技', '热血', '逆袭'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-11',
    slug: 'midnight-call',
    title: '午夜来电',
    author: '郑秀晶',
    category: 'thriller',
    categoryName: '悬疑惊悚',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20psychological%20thriller%20illustration%2C%20woman%20answering%20old%20phone%20in%20dark%20room%2C%20eerie%20blue%20glow%2C%20suspenseful%20atmosphere%2C%20clean%20webtoon%20horror%20style%2C%20long%20shadows%2C%20tense%20mood%2C%20minimalist%20composition&width=800&height=1100&seq=comic-cover-011&orientation=portrait',
    status: '连载中',
    rating: 4.5,
    views: 1670000,
    chapters: 29,
    latestChapter: '第29话 - 第十三个电话',
    updatedAt: '2026-07-01',
    description: '每到午夜十二点，电台主播朴秀晶都会接到一个神秘来电。电话那头的声音似乎在诉说着一桩未破的命案。当她开始调查时，发现自己已经成了下一个目标。',
    tags: ['心理悬疑', '犯罪', '电台', '惊悚'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-12',
    slug: 'starry-night-promise',
    title: '星空之约',
    author: '李恩雅',
    category: 'romance',
    categoryName: '浪漫爱情',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20starry%20night%20romance%20illustration%2C%20couple%20sitting%20on%20hilltop%20under%20vast%20starry%20sky%2C%20romantic%20and%20dreamy%20atmosphere%2C%20clean%20webtoon%20style%2C%20deep%20night%20sky%20with%20stars%2C%20silhouette%20composition%2C%20peaceful%20and%20tender%20mood&width=800&height=1100&seq=comic-cover-012&orientation=portrait',
    status: '连载中',
    rating: 4.9,
    views: 1980000,
    chapters: 63,
    latestChapter: '第63话 - 流星雨之夜',
    updatedAt: '2026-07-02',
    description: '天文台工作的研究员金泰浩遇到了来观星的插画师尹夏琳。在璀璨星空下，两个孤独的灵魂相遇、相知、相爱。但现实的引力总是试图将他们拉回地面。',
    tags: ['天文', '治愈', '慢热', '纯爱'],
    isHot: false,
    isNew: false,
  },
];

export const testimonials = [
  {
    id: 1,
    name: '漫画迷小月',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%2C%20soft%20natural%20lighting%2C%20warm%20smile%2C%20clean%20white%20background%2C%20editorial%20style%2C%20minimalist%20composition%2C%20professional%20headshot%2C%20gentle%20expression&width=200&height=200&seq=testimonial-avatar-01&orientation=squarish',
    role: '资深韩漫读者',
    content: '"动漫之家是我用过最好的韩漫阅读平台！无删减的内容加上下拉式的阅读体验，看漫画就像在看一部流畅的电影。更新速度也超快，每天都有新内容等着我。"',
    rating: 5,
  },
  {
    id: 2,
    name: '韩流追更达人',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%2C%20casual%20style%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20editorial%20photography%2C%20natural%20lighting%2C%20minimalist%20composition%2C%20warm%20tone&width=200&height=200&seq=testimonial-avatar-02&orientation=squarish',
    role: '韩漫爱好者',
    content: '"画质真的太清晰了！用手机看也完全不模糊，加载速度一流。而且分类特别细致，无论我想看什么类型的韩漫都能很快找到。强烈推荐给所有喜欢韩漫的朋友！"',
    rating: 5,
  },
  {
    id: 3,
    name: '漫画编辑小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20young%20woman%20portrait%2C%20professional%20style%2C%20confident%20expression%2C%20clean%20white%20background%2C%20editorial%20photography%2C%20soft%20lighting%2C%20minimalist%20composition%2C%20modern%20aesthetic&width=200&height=200&seq=testimonial-avatar-03&orientation=squarish',
    role: '专业漫画编辑',
    content: '"作为漫画行业的从业者，我对平台的品质要求很高。动漫之家的内容筛选非常专业，无删减版让读者能够完整感受作者的创作意图。这是一个真正尊重漫画艺术的平台。"',
    rating: 5,
  },
];

export const features = [
  {
    icon: 'ri-book-open-line',
    title: '海量韩漫资源',
    description: '收录超5000部韩国漫画，涵盖浪漫爱情、动作热血、悬疑惊悚、奇幻冒险等多种类型，每日更新热门新作，满足各类读者的阅读需求。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '实时更新同步',
    description: '与韩国官方同步更新，第一时间获取最新章节。专业的翻译团队确保内容质量，无删减原汁原味呈现漫画精髓。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清流畅体验',
    description: '采用先进的图片优化技术，支持高清画质阅览。下拉式阅读设计，无需翻页加载，滑动即可畅快阅读，加载速度业界领先。',
  },
];

export const mediaPraise = [
  {
    source: '漫画周刊',
    quote: '"动漫之家已经成为国内韩漫爱好者的首选平台，其无删减的内容策略和对原创作者的尊重，为行业树立了新标杆。"',
    logo: '漫画周刊',
  },
  {
    source: 'ACG观察',
    quote: '"从内容质量到阅读体验，动漫之家都在不断突破。特别是下拉式阅读的创新设计，让移动端阅读更加流畅自然。"',
    logo: 'ACG观察',
  },
];

export const teamMembers = [
  {
    name: '金秀妍',
    role: '创始人 & CEO',
    description: '曾在韩国最大漫画平台担任产品总监，拥有10年漫画行业经验。怀着对漫画的热爱，回到中国创立动漫之家。',
    image: 'https://readdy.ai/api/search-image?query=Asian%20professional%20woman%20portrait%2C%20modern%20business%20attire%2C%20confident%20and%20warm%20expression%2C%20clean%20office%20background%2C%20editorial%20style%2C%20soft%20natural%20lighting%2C%20minimalist%20composition&width=400&height=500&seq=team-01&orientation=portrait',
  },
  {
    name: '李正宇',
    role: '技术总监',
    description: '前互联网大厂资深工程师，专注于前端性能优化和用户体验设计。主导开发了动漫之家核心阅读引擎。',
    image: 'https://readdy.ai/api/search-image?query=Asian%20professional%20man%20portrait%2C%20tech%20style%2C%20friendly%20smile%2C%20clean%20office%20background%2C%20editorial%20photography%2C%20natural%20lighting%2C%20minimalist%20composition&width=400&height=500&seq=team-02&orientation=portrait',
  },
  {
    name: '朴恩惠',
    role: '内容总监',
    description: '资深韩漫编辑，精通中韩双语。负责平台内容筛选和质量把控，确保每部作品都能原汁原味地呈现给读者。',
    image: 'https://readdy.ai/api/search-image?query=Asian%20professional%20woman%20portrait%2C%20creative%20style%2C%20bright%20expression%2C%20clean%20studio%20background%2C%20editorial%20photography%2C%20soft%20lighting%2C%20warm%20tone&width=400&height=500&seq=team-03&orientation=portrait',
  },
];

export const faqs = [
  {
    question: '动漫之家的漫画都是免费的吗？',
    answer: '是的！动漫之家平台上所有韩国漫画均提供免费阅读服务。我们致力于为广大韩漫爱好者提供一个零门槛的优质阅读平台，让每一位读者都能畅享精彩漫画内容。',
  },
  {
    question: '什么是"无删减"漫画？',
    answer: '无删减漫画指的是保留原作全部内容的完整版本。与某些经过审核删改的版本不同，我们的无删减版本完整呈现了原作者的创作意图和故事情节，确保读者能够获得最原汁原味的阅读体验。',
  },
  {
    question: '下拉式阅读是什么意思？',
    answer: '下拉式阅读是动漫之家独创的漫画阅读方式。您只需在手机或电脑上向下滑动，漫画内容就会像瀑布一样连续展示，无需翻页操作。这种方式特别适合移动端阅读，让观看体验更加流畅自然。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '我们与韩国方面保持同步更新，热门漫画通常每周更新一到两话。您可以在漫画详情页查看具体的更新时间和最新章节信息。我们还提供更新提醒功能，让您不错过任何精彩内容。',
  },
  {
    question: '支持什么设备阅读？',
    answer: '动漫之家全面支持PC端、平板和手机端阅读。无论您使用什么设备，都能获得优化的阅读体验。推荐使用手机端进行阅读，下拉式设计在移动端的体验最为出色。',
  },
];

export const brandStory = {
  title: '关于动漫之家',
  subtitle: '专注韩漫免费阅读平台',
  founded: '成立于2022年',
  description1: '动漫之家诞生于创始人对韩国漫画的深厚热爱。在韩国漫画行业深耕十年后，创始人发现国内缺少一个真正优质的韩漫阅读平台——内容被删减、翻译粗糙、加载缓慢等问题困扰着无数韩漫爱好者。于是，动漫之家应运而生。',
  description2: '我们坚持"无删减、高品质、免费读"的核心理念，组建了专业的翻译和编辑团队，与韩国多家漫画工作室建立合作关系，确保每一部作品都能以最好的状态呈现给读者。从最初的小众平台到如今拥有数百万用户的韩漫阅读首选，动漫之家始终不忘初心。',
  description3: '未来，我们将持续拓展漫画资源库，优化阅读技术，为读者带来更多优质的韩国漫画作品。同时也欢迎各位创作者、出版社和商务伙伴与我们联系，共同推动韩漫文化在中国的传播与发展。',
};

export const platformStats = [
  { label: '收录漫画', value: '5,000+', icon: 'ri-bookmark-line' },
  { label: '日活用户', value: '200万+', icon: 'ri-user-star-line' },
  { label: '月更新量', value: '3,000+', icon: 'ri-refresh-line' },
  { label: '用户好评率', value: '98.6%', icon: 'ri-heart-line' },
];